import Sortable from 'sortablejs';
import ApplicationController from '../editor/application_controller';
import { createRequest } from '../helpers/createRequest';

export default class extends ApplicationController {
  connect() {
    console.log('[X1 Sorting] Controller connected');
    console.log('[X1 Sorting] Current element:', this.element);
    this.initializeSectionsSorting();
  }

  initializeSectionsSorting() {
    // Initialize sorting for design phases/sections
    const designPhasesList = document.getElementById('design-stages-list');
    
    console.log('[X1 Sorting] Looking for design-stages-list element');
    console.log('[X1 Sorting] Found element:', designPhasesList);
    
    if (designPhasesList) {
      const listItems = designPhasesList.querySelectorAll('.design-phase-item');
      console.log('[X1 Sorting] Found', listItems.length, 'design phase items:', listItems);
      
      console.log('[X1 Sorting] Creating Sortable instance');
      const sortableInstance = new Sortable(designPhasesList, {
        animation: 150,
        ghostClass: 'sortable-ghost',
        dragClass: 'sortable-drag',
        chosenClass: 'sortable-chosen',
        filter: '[data-controller="x1--dropdown"], button', // Prevent dragging from dropdown button
        preventOnFilter: false,
        onStart: (evt) => {
          console.log('[X1 Sorting] Drag started');
          console.log('[X1 Sorting] Dragged item:', evt.item);
          console.log('[X1 Sorting] From index:', evt.oldIndex);
        },
        onMove: (evt) => {
          console.log('[X1 Sorting] Moving item');
          console.log('[X1 Sorting] Related element:', evt.related);
          console.log('[X1 Sorting] Will insert at:', evt.willInsertAfter);
        },
        onEnd: (evt) => {
          console.log('[X1 Sorting] Drag ended');
          console.log('[X1 Sorting] Item:', evt.item);
          console.log('[X1 Sorting] From index:', evt.oldIndex, 'To index:', evt.newIndex);
          
          // Always update everything after any drag/drop
          this.updateAllPositions(evt);
        },
        onChoose: (evt) => {
          console.log('[X1 Sorting] Item chosen for drag:', evt.item);
        },
        onUnchoose: (evt) => {
          console.log('[X1 Sorting] Item unchosen:', evt.item);
        },
        onFilter: (evt) => {
          console.log('[X1 Sorting] Filtered element clicked:', evt.item);
        }
      });
      
      console.log('[X1 Sorting] Sortable instance created:', sortableInstance);
      console.log('[X1 Sorting] Sortable options:', sortableInstance.options);
    } else {
      console.error('[X1 Sorting] Could not find design-stages-list element!');
      console.log('[X1 Sorting] Current DOM:', document.body.innerHTML.substring(0, 500));
    }
  }

  updateAllPositions(evt) {
    console.log('[X1 Sorting] Updating all positions after drag/drop');
    const sortedItems = evt.target.querySelectorAll(':scope > li.design-phase-item');
    console.log('[X1 Sorting] Found sorted items:', sortedItems.length);
    
    // Fix borders after reordering
    sortedItems.forEach((item, index) => {
      item.classList.remove('border-b', 'border-lightest-gray');
      if (index < sortedItems.length - 1) {
        item.classList.add('border-b', 'border-lightest-gray');
      }
    });
    
    // Prepare data for both updates
    const stagePositions = [];
    let teamsIndex = -1;
    let sectionIdForGroupFormation = null;
    
    // Iterate through all items to gather positions
    [...sortedItems].forEach((item, index) => {
      if (item.id === 'teams-section') {
        teamsIndex = index;
        console.log('[X1 Sorting] Found teams at index:', teamsIndex);
      } else {
        const id = item.id.replace('section-', '');
        if (/^\d+$/.test(id)) {
          stagePositions.push({ id, ordinal: stagePositions.length + 1 });
        }
      }
    });
    
    // Determine section_id_for_group_formation based on teams position
    if (teamsIndex >= 0) {
      // Simple logic: teams position tracks which stage it comes after
      // 0 = teams at top (before all stages)
      // stage_id = teams after that stage
      // null = no teams (when teams is at the very bottom with no stages after it)
      
      let stageBeforeTeams = null;
      let hasStagesAfterTeams = false;
      
      // Find the stage immediately before teams (if any)
      for (let i = teamsIndex - 1; i >= 0; i--) {
        const item = sortedItems[i];
        if (item.id !== 'teams-section') {
          const id = item.id.replace('section-', '');
          if (/^\d+$/.test(id)) {
            stageBeforeTeams = id;
            break;
          }
        }
      }
      
      // Check if there are stages after teams
      for (let i = teamsIndex + 1; i < sortedItems.length; i++) {
        const item = sortedItems[i];
        if (item.id !== 'teams-section') {
          const id = item.id.replace('section-', '');
          if (/^\d+$/.test(id)) {
            hasStagesAfterTeams = true;
            break;
          }
        }
      }
      
      if (stageBeforeTeams) {
        // Teams comes after a stage
        sectionIdForGroupFormation = stageBeforeTeams;
        console.log('[X1 Sorting] Teams after stage:', sectionIdForGroupFormation);
      } else if (hasStagesAfterTeams) {
        // Teams at top (no stages before it)
        sectionIdForGroupFormation = 0;
        console.log('[X1 Sorting] Teams at top - setting to 0');
      } else {
        // Teams at bottom with no stages after it - remove teams
        sectionIdForGroupFormation = null;
        console.log('[X1 Sorting] Teams at bottom with no stages after - setting to null');
      }
    }
    
    console.log('[X1 Sorting] Stage positions:', stagePositions);
    console.log('[X1 Sorting] Group formation delimiter:', sectionIdForGroupFormation);
    
    const studioId = window.location.pathname.match(/studios\/(\d+)/)?.[1];
    if (!studioId) {
      console.error('[X1 Sorting] Could not determine studio ID');
      return;
    }
    
    // Send both updates in parallel
    const promises = [];
    
    // Update stage positions
    if (stagePositions.length > 0) {
      promises.push(
        fetch(createRequest('/x1/sections/positions', 'POST', JSON.stringify(stagePositions)))
          .then(response => {
            if (response.ok) {
              console.log('[X1 Sorting] Stage positions updated successfully');
            } else {
              throw new Error(`Stage positions update failed: ${response.status}`);
            }
          })
      );
    }
    
    // Update teams position if teams exists
    if (teamsIndex >= 0) {
      promises.push(
        fetch(createRequest('/x1/update_group_formation_delimiter', 'POST', JSON.stringify({
          studio_id: studioId,
          section_id: sectionIdForGroupFormation
        })))
          .then(response => {
            if (response.ok) {
              console.log('[X1 Sorting] Group formation delimiter updated successfully');
            } else {
              throw new Error(`Group formation update failed: ${response.status}`);
            }
          })
      );
    }
    
    // Wait for all updates to complete
    Promise.all(promises)
      .then(() => {
        console.log('[X1 Sorting] All updates completed successfully');
      })
      .catch(error => {
        console.error('[X1 Sorting] Error updating positions:', error);
        // Revert on failure
        location.reload();
      });
  }
}